import React from "react";
import { BellRing } from "lucide-react";
import CustomSwitch from "@/shared/components/ui/Switch/CustomSwitch";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";
import {
  useFollowUpAlert,
  useSetFollowUpAlert,
} from "@/features/accounts/hooks/useAccounts";
import { getFollowUpReviewStatus } from "@/features/dashboard/utils/accountsDashboardUtils";

const FollowUpAlertToggle = ({ companyName }) => {
  const { data: alert, isLoading, isError } = useFollowUpAlert({ companyName });
  const { mutate: setAlert, isPending } = useSetFollowUpAlert();
  const enabled = Boolean(alert?.enabled);

  if (isError) return null;

  return (
    <CustomCommonTooltip
      placement="bottom"
      content={
        getFollowUpReviewStatus(alert) ||
        "Turn on to get AI follow-up suggestions from this account's emails, meetings and calls every 4 days."
      }
    >
      <div className="flex items-center gap-2">
        <BellRing
          size={15}
          strokeWidth={2.2}
          className={enabled ? "text-secondary" : "text-gray-500 dark:text-gray-400"}
        />
        <span className="whitespace-nowrap text-[0.763rem] font-medium text-gray-700 dark:text-gray-300">
          Follow-up alerts
        </span>
        <CustomSwitch
          size="sm"
          isChecked={enabled}
          disabled={isLoading || isPending}
          onChange={(next) => setAlert({ companyName, enabled: next })}
          aria-label="Follow-up alerts"
        />
      </div>
    </CustomCommonTooltip>
  );
};

export default FollowUpAlertToggle;
